import React, { useState, useEffect, useMemo } from "react";
import "./3dResume.css";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Row,
  Col,
  Rate,
  Input,
  Typography,
  Slider,
  Carousel,
  Progress,
  Spin
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment";
import { getImage } from "../../utilities/storageOperations/downloadURL";
import googleIcon from "../../assets/img/google@3x.png";
import { useLocation } from "react-router-dom";
import linkedinIcon from "../../assets/img/linkedin-filled.png";

import facebookIcon from "../../assets/img/facebook-filled@3x.png";
import Frame from "../../assets/img/Top_rated@2x.svg";
import SkillIndex from "./components/SkillIndex/SkillIndex";
import IndustryDensity from "./components/IndustryDensity/IndustryDensity";
import { getResume3d, removefollower, addfollower, viewIncrement, getOneUserSkillListing,removePrivateTalentInit } from "../../redux/actions";
import Loader from "../../components/Loading/Loader";
import healthwf from "../../assets/img/healthwf.png";
import medal from "../../assets/img/medal.png";
import PdfMaker from "./components/PdfMaker/PdfMaker";
import history from "../../routes/history";

import zigzagLineIcon from "../../assets/icons/zigzagLineIcon.svg";
import backButton from "../../assets/icons/backButton.svg";
import purpleTriangleIcon from "../../assets/icons/purpleTriangleIcon.svg";
import redTriangleIcon from "../../assets/icons/redTriangleIcon.svg";
import greenLineIcon from "../../assets/icons/greenLineIcon.svg";
import yellowArcIcon from "../../assets/icons/yellowArcIcon.svg";

import TopAlert from "../../components/TopNotification/TopAlert";
import { indexOf } from "lodash";
import { BsStackOverflow, BsTelephone } from "react-icons/bs";
import { GrGithub } from "react-icons/gr"
import { AiOutlineMail } from "react-icons/ai";
import { formatPhoneNumber } from "../../shared/helpers";
import PopupModal from "./components/PopupModal/PopupModal";
import PrivateTagSkillListing from "../../components/PrivateMarketComponents/PrivateTagSkillListing";



const dummyData = [
  {
    name: "No Data",
    value: "",
  },
  {
    name: "No Data",
    value: "",
  },
  {
    name: "No Data",
    value: "",
  },
];
let rows = [];
for (let i = 0; i < 30; i++) {
  rows.push(i);
}

let rows2 = [];
for (let i = 0; i < 31; i++) {
  rows2.push(i);
}

export default function Resume3d() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { Text } = Typography;
  const [profile, setProfile] = useState(null);
  const[popUpTrue,setpopUpTrue] = useState(false)
  const [educationHistory, setEducationHistory] = useState(null);
  const [careerRecords, setCareerRecords] = useState(null);
  const [sliderValue, setSliderValue] = useState(0);
  const [credentials, setCredentials] = useState(null);
  const [isFollowed, setisFollowed] = useState(false);
  const [image, setImage] = useState("");
  const [marks, setmarks] = useState({});
  const [uploadedCount, setUploadedCount] = useState();
  const [facebookLink, setFacebookLink] = useState("");
  const [linkedInLink, setLinkedInLink] = useState("");
  const [careerData, setCareerData] = useState("");
  const [imagesGenrated, setImagesGenerated] = useState(false);
  const [error, setError] = useState(false);
  const [imgURL, setImgURL] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);


  const [careerWithYears, setCareerWithYears] = useState([]);

  const [uniqueYears, setUniqueYears] = useState([]);

  const [currentRecords, setCurrentRecords] = useState([]);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [userProfileState, setuserProfileState] = useState(userProfile);

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  var cache = {},
    character,
    e = document.createElement("div");




  // const marks = {
  //   0: "2010",
  //   1: "2012",
  //   2: "2014",
  //   3: "2016"

  // };

  const id = location?.state?.candidateid;
  const resume = useSelector((state) => state.getResume3dReducer.resumedetails);
  const resumeHide = useSelector((state) => state?.getResume3dReducer?.resumedetails?.skilllisting);
  const loading = useSelector((state) => state.getResume3dReducer.loading);
  const forFollowLoading = useSelector((state) => state.getResume3dReducer.forFollowLoading);
  const showBackButton = location.state?.fromSpecificRedirect;
  const userSKillListing = useSelector(
    (state) => state.oneUserskillListingReducer.skillListings
  );
  const Pdetails = useSelector(
    (state) => state.getProfileDetailsReducer.details
  );

  const followUnFollowLoading = useSelector(
    (state) => state.followUnFollowReducer.loading
  );
  const followSuccess = useSelector(
    (state) => state.followUnFollowReducer.follow_success
  );
  const unFollowSuccess = useSelector(
    (state) => state.followUnFollowReducer.unfollow_success
  );

  const [imageError, setImageError] = useState(false);
  const [data, setData] = useState(0)
  // let data = resume?.followers ? resume?.followers.length  : 0

    useEffect(() => {      
    dispatch(viewIncrement(id));
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (resumeHide && userSKillListing?.bid?.length === undefined) {
      dispatch(
        getOneUserSkillListing({
          skillId: resumeHide[0]?.SkillListingId,
          jobId:
            location?.state?.jobId ??
            location?.search.split("jobId=")[1]?.split("&")[0],
        })
      );
    }
  }, [resumeHide, userSKillListing?.bid?.length]);

  useEffect(() => {
    setData(resume?.followers?.length)
    setisFollowed(resume?.IsFollower)
    if (location.state?.fromChat) {
      const element = document.getElementById('section-1');
      if (element) {
        // 👇 Will scroll smoothly to the top of the next section
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [resume]);

  function removeEmployeeAssociation(employeeIdToRemove) {
    const updatedEmployeeAssociation = userProfile.EmployeeAssociation.filter(id => id == employeeIdToRemove);
    const UpdateData = { ...userProfile, EmployeeAssociation: updatedEmployeeAssociation };
    setuserProfileState(UpdateData);
    return UpdateData;
  }
  const removePvtResponse = useSelector(
    (state) => state.getProfileDetailsReducer.RemoveTalentPrivate
  );
  useEffect(() => {
    if (removePvtResponse) {
      localStorage.setItem('userProfile', JSON.stringify(removeEmployeeAssociation(userProfile, Pdetails?.skill_listings[0]?.Profiles?.Accounts?.AccountId)));
    }
  }, [removePvtResponse])

  useEffect(async () => {
    if (resume?.profile?.Profiles?.PictureUrl) {
      setImgURL( resume?.profile?.Profiles?.PictureUrl);
      setImage( resume?.profile?.Profiles?.PictureUrl);
    }
  }, [resume]);


  useEffect(() => {
    dispatch(getResume3d({id, forFollow: followSuccess || unFollowSuccess}));
  }, []);//followSuccess, unFollowSuccess

  useEffect(() => {
    if (Object.keys(resume).length > 0) {
      getResume();
    }
  }, [loading, resume]);

  useEffect(() => {
    if (resume?.career_records) {
      let years = resume?.career_records.filter((item) => item?.Deleted ? item?.Deleted == false : true).map((item) => { return { ...item, year: new Date(item.StartDate).getFullYear() } });
      setCareerWithYears(years);
      let uniqueYears = [... new Set(years.map((o) => o.year))];
      let defaultRecord = years.filter((item) => item.year == uniqueYears[0]);
      setCurrentRecords(defaultRecord);
      setUniqueYears(uniqueYears);
    }
  }, [resume]);


  const getResume = () => {
    setEducationHistory(resume?.academic_records?.filter((item) => item?.Deleted ? item?.Deleted == false : true));
    setCredentials(resume?.Credentials);
    // let careerRecordsArray = resume?.career_records.sort(function(a,b){
    //   return new Date(b.StartDate) - new Date(a.StartDate);
    // })

    setCareerRecords(resume?.career_records.filter((item) => item?.Deleted ? item?.Deleted == false : true));
    // if (imgURL) {
    //   setImage(`${process.env.REACT_APP_S3_URL}${imgURL?.charAt(0) !== "/" ? '/' : ""}${imgURL}`);
    // }else{
    //   setImage('')
    // }

    var markArary = resume?.career_records?.filter((item) => item?.Deleted ? item?.Deleted == false : true)?.map((item, index) => {
      return item?.StartDate?.slice(0, 4);
    });

    setmarks(markArary);
  };

//   console.log("Resume for shehla", careerRecords)
  const memoizedSkillIndex = useMemo(() => {
    if (Object.keys(resume)?.length > 0 && resume?.skillindex?.length > 0) {
      return <SkillIndex data={resume?.skillindex} />;
    } else {

      return <SkillIndex dummy={dummyData} />;
    }
  }, [resume]);

  const memoizedIndustryDensity = useMemo(() => {
    if (Object.keys(resume).length > 0 && resume?.industrydensity.length > 0) {
      return <IndustryDensity data={resume?.industrydensity} />;
    }
  }, [resume]);

  const addFollowerHandler = () => {
    dispatch(
      addfollower({
        id: resume?.profile?.AccountId,
      })
    );
    setData(data + 1)
    setisFollowed(!isFollowed);
  };
  const handleBack = () => {
    history.goBack(); 
  };
  const removeFollowerHandler = () => {
    dispatch(
      removefollower({
        id: resume?.profile?.AccountId,
      })
    );
    if(data == 0){
      setData(0)
    }
    else {
      setData(data - 1)
    }
    setisFollowed(!isFollowed);
  };

  const getRecordValue = (e, length) => {
    let value = e.target.value;
    let step = Math.round(100 / (length - 1));
    setSliderValue(Math.round(+value / step) * step);
    getIndexValue(Math.round(+value / step) * step, uniqueYears.length);
  }
  const getIndexValue = (e, length) => {
    // let value = e.target.value;
    let step = Math.round(100 / (length - 1));
    let index = Math.round(+e / step);
    let yearSelected = uniqueYears[index];
    let filtered = careerWithYears.filter((item) => item.year == yearSelected);
    setCurrentRecords(filtered);


    // setSliderValue( Math.round(+value/step)*step)

    return (Math.round(+e / step))
  }
  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
          character = cache[entity] = e.childNodes[0].nodeValue;
        else character = "";
      }
      return character;
    });
  };

  useEffect(() => {
    if (resume?.profile) {
      setFacebookLink(resume?.profile?.Profiles?.Facebook)
      setLinkedInLink(resume?.profile?.Profiles?.LinkedIn);

      let array = Array(resume?.career_records?.filter((item) => item?.Deleted ? item?.Deleted == false : true));
      // let arrayData = array;
      setCareerData(array)



      {
        resume?.Credentials?.length ?
        setUploadedCount(resume?.Credentials?.length)
        :
        setUploadedCount(0)
      }

      //   {resume?.profile?.profile?.Objective &&
    }
  }, [resume]);
  const removePvtLoading = useSelector(
    (state) => state.getProfileDetailsReducer.loadingPrivate
  );
  function removePvtTalent() {
    setShowConfirmationModal(true);
    // dispatch(removePrivateTalentInit(Pdetails?.skill_listings[0]?.Profiles?.Accounts?.AccountId)); 
  }
  

  return resume?.length === 0 || loading==true ? (
    <Loader />
  ) : (
    <div className="resume-3d-container">
                           {showBackButton && (
        <p
          onClick={handleBack}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            textAlign:'center',
            marginBottom:'1.2rem'
          }}
        >
          <img
            src={backButton}
            alt="back-button"
            style={{ paddingLeft: "10px", width: "20px", height: "20px" }}
          />
          <span style={{ color: "#4054B2", paddingLeft: "10px",fontSize:'12px' }}>back</span>
        </p>
      )}
     
      {imagesGenrated ? (
        <TopAlert
          display={"flex"}
          title={"PDF successfully downloaded"}
          type="success"
        />
      ) : null}

        {error ? (
          <TopAlert
            display={"flex"}
            title={"Cannot create PDF for doc files"}
            type="warning"
          />
        ) : null}
       
        {showBackButton && windowDimensions.width <= 768 && (
        <p
          onClick={handleBack}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            textAlign:'center',
            marginBottom:'0.2rem'
          }}
        >
          <img
            src={backButton}
            alt="back-button"
            style={{ paddingLeft: "10px", width: "20px", height: "20px" }}
          />
          <span style={{ color: "#4054B2", paddingLeft: "10px",fontSize:'12px' }}>back</span>
        </p>
      )}
      <Row
        className={
          windowDimensions.width < 992
            ? "resume-3d-div resume-3d-headerCont-mobile"
            : "resume-3d-div resume-3d-headerCont-desktop"
        }
      >
        <Col xs={24} sm={24} md={24} lg={12} xl={12} className="rightDivider">
          <div className="prodetailsContainer">
            <div
              className={
                windowDimensions.width < 992
                  ? "profileImgCont profileCont-mobile"
                  : "profileImgCont profileCont-desktop"
              }
            >
              <div>
                <div className="img-container img-container-size">
                {image && !imageError && image?.split("/")?.pop() !== "no-pic.png" ? (
                    <img
                      className="profile-image-candidate-bids"
                      src={`${process.env.REACT_APP_S3_URL}${
                        image?.charAt(0) !== "/" ? "/" : ""
                      }${image}`}
                      onError={() => setImageError(true)}
                    />
                  ) : (
                    <Text style={{ color: "#fff", }} className="img-text1">
                      {resume?.profile?.Profiles.FirstName
                        ? //resume?.profile[0].profile.FirstName.toUpperCase()
                        (resume?.profile?.Profiles?.FirstName?.split("")[0]).toUpperCase()
                        : ""}
                    </Text>
                  )}
                  
                </div>
                <div className="top-rated top-rated-position">
                <div className={windowDimensions.width > 991 ? "avatarWeb" : "avatarMobile"}>
                   {userProfile.EmployeeAssociation.includes(Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.AccountId) ? <PrivateTagSkillListing /> : ""}

                 </div>
                  {/* <img className="top_rated_logo" src={Frame} /> */}
                </div>
              </div>
            </div>
            <div
              className={
                windowDimensions.width < 992
                  ? "profileCont-mobile"
                  : "profileCont-desktop"
              }
            >
              <div className="resume-3d-name topmargin" style={{ marginTop: '5rem' }} >
                {resume?.profile?.Profiles?.FirstName}{" "}
                {resume?.profile?.Profiles?.LastName}
              </div>
              {resume?.profile?.Profiles?.Discipline ?
                (
                  <div className="resume-3d-name textTitle">
                    {resume?.profile?.Profile?.Discipline}
                  </div>
                )
                :
                ''
              }
              

              <div className="resume-3d-name textTitle marginBottom">
                {resume?.profile.Profiles?.Location?.Location ? resume?.profile.Profiles?.Location?.Location : resume?.profile.Profiles?.Cities?.CityName}
              </div>


                {/* { (location?.state?.candidateBidinfo?.length > 0 || location?.state?.hired) && */}
                {(userSKillListing?.bid?.length > 0 || Pdetails?.user_Schema?.hired == true) && <div className="contact-info-row">
                  <div className="icon-and-info"
                   style={{
                    width: 'fit-content',
                    marginBottom:'5px',
                    paddingRight:windowDimensions.width > 769 &&'40px',
                    wordBreak: 'break-all',
                    whiteSpace:'nowrap'
                    }}
                    >
                    <AiOutlineMail 
                    className="AiOutlineMail-icon"
                    />
            <span style={{marginLeft:'7px'}}> {resume?.profile.EmailAddress}</span>{/*  */}
                  </div>
                  {
                    resume?.profile?.Profiles?.MobilePhone &&
                  <div className="icon-and-info"
                  style={{
                    marginBottom:'5px',
                    width: windowDimensions.width < 990 &&  windowDimensions.width >770 ? '18%': '35%', 
                    // backgroundColor:'pink'                 
                    }}
                    >
                    <BsTelephone />
                    <span style={{
                     marginLeft:'7px'
                     }}> 
                      {formatPhoneNumber(resume?.profile?.Profiles?.MobilePhone)}</span>
                  </div>
                  }
                </div>}
                {/* }  */}
                {(userSKillListing?.bid?.length > 0 || Pdetails?.user_Schema?.hired == true) && <div className="Social">
                {resume?.profile?.Profiles?.ProfileSocialMedia?.length > 0 ?
                  <Row className="socialIconsCont">

                    
                      {resume?.profile?.Profiles?.ProfileSocialMedia.map((item, index) => {
                      return (  
                        (item?.SocialMediaType?.SocialMediaTypeCode === "FB") ?  
                        <a 
                        key={index}
                        href={item?.SocialMediaType
                          ?.SocialMediaTypeURL +
                          item?.SocialMediaTypeSlug} 
                          >
                          <img
                            className={
                              windowDimensions.width < 992
                              ? "resume-3d-icons-mobile"
                              : "resume-3d-icons-desktop"
                            }
                            src={facebookIcon}
                            alt="facebookIcon"
                            target="_blank"
                          ></img>
                        </a> 
                         :
                         (item?.SocialMediaType?.SocialMediaTypeCode === "LI") ?    
                          <a 
                          href={item?.SocialMediaType
                            ?.SocialMediaTypeURL +
                            item?.SocialMediaTypeSlug}
                            target="_blank"
                          >

                            <img
                              className={
                                windowDimensions.width < 992
                                  ? "resume-3d-icons-mobile"
                                  : "resume-3d-icons-desktop"
                              }
                              src={linkedinIcon}
                              alt="linkedinicon"
                            ></img>
                          </a>
                            : (item?.SocialMediaType?.SocialMediaTypeCode === "GH") ?    
                             (   
                              <a
                                href={
                                  item?.SocialMediaType
                                    ?.SocialMediaTypeURL +
                                  item?.SocialMediaTypeSlug
                                }
                                target="_blank"
                                className="candidate-social-iconResume"
                              >
                                <GrGithub 
                                style={{
                                  color:"#fff",
                                  fontSize:windowDimensions.width < 992 ? '23px': '27px',
                                  marginBottom:'4px' , 
                                  marginRight:windowDimensions.width < 992 ?'16px': '12px' }}
                                />
                              </a>
                           )   
                             :  (item?.SocialMediaType?.SocialMediaTypeCode === "SO") ?    
                               (    
                                <a
                                  href={
                                    item?.SocialMediaType
                                      ?.SocialMediaTypeURL +
                                    item?.SocialMediaTypeSlug
                                  }
                                  target="_blank"
                                  className="candidate-social-iconResume"
                                >
                                  <BsStackOverflow 
                                 style={{
                                  color:"#fff",
                                  fontSize:windowDimensions.width < 992 ? '23px': '27px',
                                  marginBottom:'4px' 
                                }}
                                 />
                                </a>
                                 )     
                                 : null    

                         )
                    })}    

                  </Row> : null}
              </div>}
            </div>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <div
            className={
              windowDimensions.width > 991 ? "profileSkillsContPadding" : ""
            }
          >
            {windowDimensions.width > 991 ? (
              <Row className="skillViewsContainer">
                <div className="containerSkills rightBorder" onClick={() =>
                  history.push({
                    pathname: "/candidateskilllisting",
                    state: {
                      // id: resume?.Profiles._id,
                      id: resume?.profile?.AccountId,
                      fname: resume?.profile?.Profiles?.FirstName,
                      lname: resume?.profile?.Profiles?.lastName
                    },
                  })
                } >

                  <div className="textTitle">Skill listings</div>
                  <div className="textValue">
                    {resume?.skilllistings ? resume?.skilllistings : 0}
                  </div>
                </div>
                <div className="containerSkills rightBorder" style={{ cursor: resume?.followers == 0 ? 'default' : 'pointer' }} onClick={() =>
                  history.push({
                    pathname: `/followers/${resume?.profile?.AccountId}`,
                    state: {
                      // id: resume?.Profiles._id,
                      id: resume?.profile?.AccountId,
                      fname: resume?.profile?.Profiles?.FirstName,
                      lname: resume?.profile?.Profiles?.lastName
                    },
                  })
                }>
                  <div className="textTitle">Followers</div>
                  <div className="textValue">
                    {data}
                  </div>
                </div>
                <div className="containerViews" onClick={() =>
                  history.push({
                    pathname: "/views",
                    state: {
                      id,
                    },
                  })
                }>
                  <div className="textTitle">Views</div>
                  <div className="textValue">
                    {resume?.views ? resume?.views : 0}
                  </div>
                </div>
              </Row>
            ) : null}
           {/* Paste it here below */}
           <Row className="resume-3d-btnCont" style={{marginBottom: "25px"}}>
  <Col xs={24} sm={12}>
    {isFollowed ? (
      <Button
        className={
          windowDimensions.width > 991
            ? "resume-3d-btn btnfollowing"
            : "resume-3d-btn btnfollowingMobile"
        }
        onClick={() => removeFollowerHandler()}
      >
        Following 
        {/* {followUnFollowLoading ? <LoadingOutlined /> : null} */}
      </Button>
    ) : (
      <>
        <Button
          className={
            windowDimensions.width > 991
              ? "resume-3d-btn btnfollow"
              : "resume-3d-btn btnfollowMobile"
          }
          onClick={() => addFollowerHandler()}
        >
          Follow
          {/* {isFollowed ? <LoadingOutlined /> : null} */}
        </Button>
      </>
    )}
  </Col>
  <Col xs={24} sm={12} className={
          windowDimensions.width > 575
            ? ""
            : "mobileView"
        }>
    {  userProfile?.EmployeeAssociation?.includes(id) ? (
      <Button
        className={
          windowDimensions.width > 991
            ? "resume-web"
            : "resume-mobile"
        }
        onClick={removePvtTalent}
      >
        {removePvtLoading ? (
          <>
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: "#fff"
                  }}
                  spin
                />
              }
            />
          </>
        ) : (
          "Remove from private marketplace"
        )}
      </Button>
    ) : null}
  </Col>
  <PopupModal id={id} show={showConfirmationModal} onClose={()=>{setShowConfirmationModal(false)}} popUpTrue={popUpTrue} setpopUpTrue={setpopUpTrue}/>
</Row>

            
          </div>
         
        </Col>

        <img className="zigzagLineIcon" src={zigzagLineIcon} alt="" />
        <img className="purpleTriangleIcon" src={purpleTriangleIcon} alt="" />
        <img className="redTriangleIcon_1" src={redTriangleIcon} alt="" />
        <img className="redTriangleIcon_2" src={redTriangleIcon} alt="" />
        <img className="greenLineIcon" src={greenLineIcon} alt="" />
        <img className="yellowArcIcon_1" src={yellowArcIcon} alt="" />
        <img className="yellowArcIcon_2" src={yellowArcIcon} alt="" />
      </Row>

      <Row className="profileSkillsCont">
        <Col
          span={8}
          onClick={() =>
            history.push({
              pathname: "/candidateskilllisting",
              state: {
                id: resume?.profile?.AccountId,
                fname: resume?.profile?.Profiles?.FirstName,
                lname: resume?.profile?.Profiles?.lastName

              },
            })
          }

        >
          {resume?.skilllistings ? (
            <Row className="resume-3d-followings">{resume?.skilllistings}</Row>
          ) : (
            <Row className="resume-3d-followings">0</Row>
          )}
          <Row className="resume-3d-followings-txt"> Skill listings</Row>
        </Col>
        <Col span={8} onClick={() => {
          // history.push({
          //   pathname: "/followers",
          //   state: {
          //     candidateId: id
          //   },
          // })
        }}>
          {resume?.followers ? (
            <Row className="resume-3d-followings"> {resume?.followers?.length} </Row>
          ) : (
            <Row className="resume-3d-followings"> 0 </Row>
          )}
          <Row className="resume-3d-followings-txt"> Followers </Row>
        </Col>
        <Col span={8} onClick={() => {
          // history.push({
          //   pathname: "/views",
          //   state: {
          //     candidateId: id
          //   },
          // })
        }}>
          {resume?.views ? (
            <Row className="resume-3d-followings">{resume?.views}</Row>
          ) : (
            <Row className="resume-3d-followings">0</Row>
          )}
          <Row className="resume-3d-followings-txt">Views</Row>
        </Col>
      </Row>
      {windowDimensions.width < 992 ? (
        <div className="resume-3d-divider"></div>
      ) : null}

      <div className="resume3d-BodyContainer">
        <div className="subContainer">
          <div className="resume-3d-card-headings credentialing">
            Career summary
          </div>
          {resume?.profile.Profiles.Description || resume?.profile.Profiles.Objective ? (
            <div>{resume?.profile.Profiles.Description ? resume?.profile.Profiles.Description : resume?.profile.Profiles.Objective}</div>   //resume?.profile.profile.Objective
          ) : (
            <div className="resume-3d-card-box">
              <p className="noData-Text">NO DATA</p>
            </div>
          )}
          <div className="resume-3d-sub-divider"></div>
          <div className="resume-3d-card-headings credentialing">
            Skill index
          </div>
          <div className="skillIndexResume">
            <div className={resume?.skillindex?.length == 0 ? "skillIndexContainerNoData" : "skillIndexContainer"}  >{memoizedSkillIndex}</div>
          </div>
          <div className="resume-3d-sub-divider"></div>
          <div className="resume-3d-card-headings credentialing">
            Career history
          </div>
          {/* <div className="slider-container">

            <Slider
              min={0}
              max={careerRecords ? careerRecords?.length - 1 : 2}
              step={1}
              marks={marks}
              onChange={(val) => setSliderValue(val)}
            />

          </div> */}
          <div className="slide-container">
            <div className="yearsRow">
              {uniqueYears?.map((res, index) => {
                return (
                  <>
                    <div key={index} className="sliderYear">{res}</div>
                  </>
                )
              })
              }
              {/* <div className="sliderYear">2022</div>
              <div className="sliderYear">2012</div>
              <div className="sliderYear">2000</div>
              <div className="sliderYear">1992</div>
              <div className="sliderYear">1982</div> */}
            </div>
            <div className="horizonatalLineContainer1">
              {rows.map((i, index) => (
                <div key={index} className="horizontalLine">-</div>
              ))}
            </div>
            <div className="verticalLineContainer1">
              {rows2.map((i, index) => (
                <div key={index} className="verticalLine">-</div>
              ))}
            </div>
            <div className="sliderr">
              <input
                disabled={uniqueYears.length == 1}
                type="range"
                min="0"
                max="100"
                list="records"
                step={uniqueYears.length}
                value={sliderValue}
                className="slider"
                onChange={(e) => {
                  setSliderValue(e.target.value);
                  getRecordValue(e, uniqueYears.length);

                  // setCareerRecords(uniqueYears[e.target.value]);

                  return;

                }}
              />
            </div>
            <div className="verticalLineContainer2">
              {rows2.map((i, index) => (
                <div key={index} className="verticalLine">-</div>
              ))}
            </div>
            <div className="horizonatalLineContainer2">
              {rows.map((i, index) => (
                <span key={index} className="horizontalLine">-</span>
              ))}
            </div>
          </div>

          {(currentRecords && currentRecords?.length !== 0) ? currentRecords.map((item, key) => (
            <div className="careerRecordContainer" key={key}>
              <div className="careerPadding careerTitleContainer">
                <Text className="textBold">
                  {item?.Title} {"@" + item.CompanyName}
                </Text>
                <Text className="textBoldRegular resume-margin">
                  {moment(item.StartDate).format(
                    " MMMM DD, YYYY"
                  ) + " - "}
                  {item.EndDate
                    ? moment(item.EndDate).format(
                      " MMMM DD, YYYY"
                    )
                    : "Current"}
                </Text>
              </div>
              <div className="resume-3d-divider"></div>
              <div className="careerPadding">
              {(item?.Consultants_CareerRecords_Responsibilities?.length > 0 && item?.Consultants_CareerRecords_Responsibilities?.Description) || item?.Description &&
                  <>
                    <Text className="textBold">Role Description</Text>

                    <Row>
                      <Text className="textBoldRegular resume-margin">
                          {item?.Description}
                      </Text>
                    </Row>
                  </>
                }

                {(item?.Consultants_CareerRecords_Responsibilities?.length > 0 && item?.Consultants_CareerRecords_Responsibilities?.Description) || item?.Description &&
                  <>
                    <Text className="textBold">Responsibilities</Text>

                    <Row>
                      <Text className="textBoldRegular resume-margin">
                        <div dangerouslySetInnerHTML={{
                          __html: msgtxt(item?.Consultants_CareerRecords_Responsibilities
                            ?.length > 0 ? item?.Consultants_CareerRecords_Responsibilities
                            [0]?.Description : item?.Responsibilities)
                        }}
                        ></div>
                      </Text>
                    </Row>
                  </>
                }
                {item?.Consultants_CareerRecordSkills.length > 0 &&
                  <>
                    <Text className="textBold">Skills</Text>
                    {item.Consultants_CareerRecordSkills.map((skillItem, index) => {
                      return (
                        <Row key={index}>
                          <div className="skillsContainer-3D">
                            <Text className="skillsText" key={index}>
                              {skillItem.Skills?.SkillName + " (" + skillItem?.SkillPercent + "%)"}
                            </Text>
                          </div>
                        </Row>
                      );
                    })}
                  </>
                }
              </div>
            </div>
          )) : (
            <div className="resume-3d-card-box">
              <p className="noData-Text">NO DATA</p>
            </div>
          )}
          <div className="resume-3d-sub-divider"></div>
          <div className="resume-3d-card-headings credentialing">
            Industry density
          </div>
          <div className="resume-3d-card-headings-txt">
            {resume?.profile.name} The candidate’s top 5 industry experiences displayed in percentages
          </div>
          {resume?.industrydensity.length ? (
            <>{memoizedIndustryDensity}</>
          ) : (
            <div className="resume-3d-card-box">
              <p className="noData-Text">NO DATA</p>
            </div>
          )}
          <div className="resume-3d-sub-divider"></div>
          <div className="resume-3d-card-headings credentialing">
            Education
          </div>
          {educationHistory && educationHistory.length !== 0 ? (
            <div className="resume-3d-education-card">
              <Carousel
                autoplay
                arrows
                dots
                prevArrow={<LeftOutlined />}
                nextArrow={<RightOutlined />}
              >
                {educationHistory?.map((item, index) => {
                  return (
                    <Row className="resume-carousal-container" key={index}>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={12}
                        className="resume-3d-centerdiv"
                      >
                        <div className="resume-3d-pic-container">
                          <img
                            src={medal}
                            alt="medalpic"
                            style={{ width: "100%", height: "100%" }}
                          ></img>
                          <div className="resume-3d-pic-center">
                            <div className="resume-3d-yr-uni">
                              {item.YearCompleted}
                            </div>
                            <div className="resume-3d-yr-uni">
                              {item?.Schools?.SchoolName}
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={12}
                        className="resume-3d-centerdiv"
                      >
                        <div className="resume-3d-yr-uni r3dcourse">
                          {item.Courses?.CourseName}
                        </div>
                        <div className="resume-3d-yr-uni r3ddegree">
                          {item.CourseTypes?.CourseTypeName}
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Carousel>
            </div>
          ) : (
            <div className="resume-3d-card-box">
              <p className="noData-Text">NO DATA</p>
            </div>
          )}
          <div className="resume-3d-sub-divider"></div>


          {userProfile?.Professions?.ProfessionCode == 'IT' ? null :
            <Row>
              <Col className="pdf-container">
                <div className="resume-3d-card-headings credentialing">
                My credentials
                </div>
                {credentials?.length != 0 ? (
                  <div className="resume-3d-card-headings credentialing-sub-heading">
                    Uploaded documents ({uploadedCount}/83)
                  </div>
                )
                  :
                  null}

                <div className="resume-3d-card-headings credentialing-sub-heading">
                  Download a PDF package of materials
                </div>

                <div className="resume-3d-card-headings-txt">
                  {/* <h3>Download a PDF package of materials</h3> */}
                  Generate and download a package of the candidate’s materials. Drag documents to rearrange the order of the credentials to create your PDF package.
                </div>
                <div id="section-1" >
                  {credentials && credentials.length !== 0 ? (
                    <PdfMaker
                      data={credentials}
                      imagesGenrated={imagesGenrated}
                      setImagesGenerated={setImagesGenerated}
                      conversationId={location.state.conversationId}
                      error={error}
                      setError={setError}
                    />

                  ) : (
                    <div  >
                      <div className="resume-3d-card-box">
                        <p className="noData-Text">NO DATA</p>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          }
        </div>
      </div>
    </div>
  );
}

